import { ConfirmDialog } from '@/components/confirm-dialog';

// Phase 8.5-05 — thin wrapper around the generic `<ConfirmDialog>` with
// destructive-action defaults. Existing call-sites (account/campaign/
// client/warehouse detail pages) keep working unchanged. Will be deleted
// in Phase 8.5-07 cleanup once those call-sites migrate to `<ConfirmDialog
// confirmVariant="destructive">` directly.
export interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  onConfirm: () => void;
  isPending?: boolean;
  confirmLabel?: string;
}

export const ConfirmDeleteDialog = ({
  confirmLabel = 'Удалить',
  ...rest
}: ConfirmDeleteDialogProps) => (
  <ConfirmDialog
    {...rest}
    confirmLabel={confirmLabel}
    pendingLabel="Удаление…"
    confirmVariant="destructive"
  />
);
